<template>
  <div class="platform-information">
    <el-card>
      <div class="search-box-select">
            <label class="search-title">仓库名称：</label>
            <!-- 仓库名称 - 下拉框 -->
            <warehouse-select style="width: 200px !important" ref="warehouseSelect" :warehouseCode.sync="warehouseCode"></warehouse-select>
            <span class="search">
              <el-button type="primary" @click='search'>搜索</el-button>
              <el-button @click="reset">重置</el-button>
            </span>
    </div>
    </el-card>
    <!-- 列表 S -->
    <page-table ref="pageTable"
                :refresh="refresh"
                :selection="true"
                :list="notVerifyListd"
                permission="goodsManage"
                :fieldList="fieldList"
                :page="page"
                :size="size"
                :handleSlot='true'
                deleteName="goodsCode"
                :btns="['handle']">
      <template v-slot:col-boxLong="scope">
        {{ scope.row.boxLong }}
      </template>
      <template v-slot:col-boxWide="scope">
        {{ scope.row.boxWide }}
      </template>
      <template v-slot:col-boxHigh="scope">
        {{ scope.row.boxHigh }}
      </template>
      <template v-slot:col-volume="scope">
        {{ scope.row.volume }}
      </template>
      <template v-slot:col-weight="scope">
        {{ scope.row.weight }}
      </template>
      <template v-slot:col-salePrice="scope">
        {{ scope.row.salePrice }}元
      </template>
       <template v-slot:col-createFlag="scope">
        <span v-if="scope.row.createFlag === 0">仓库创建</span>
        <span v-if="scope.row.createFlag === 1">供应商创建</span>
      </template>
      <template v-slot:col-openStatus="scope">
        <span v-if="scope.row.openStatus === 0">关</span>
        <span v-if="scope.row.openStatus === 1">开</span>
      </template>
       <template v-slot:col-ygExpDays="scope">
        <span v-if="scope.row.ygExpDays">{{scope.row.ygExpDays}}</span>
      </template>
      <template v-slot:custom-buttons_right>
        <el-button type="primary"
                   :disabled="$has('goodsManageImport')" @click="examine(false)">批量已审</el-button>
      </template>
      <template v-slot:handleSlot="scope">
        <div class="handle-btn">
          <el-button type="text" :disabled="$has('goodsManageEdit')" @click="examine(scope.row)">已审</el-button>
          <el-button type="text" :disabled="$has('goodsManageEdit')" @click="edit(scope.row)">编辑</el-button>
          <el-button type="text" :disabled="$has('goodsManageDelete')" @click="deletes(scope.row)">删除</el-button>
        </div>
      </template>
    </page-table>
    <!-- 列表 E -->

  </div>
</template>

<script>
import pageTable from '@/components/Table/Index'
import goodsManage from '@/store/goodsManage/index.js'
import { GETNOTPASSGOODD, GOODSPASSGOOD, GOODSDELETE } from '@/store/goodsManage/types.js'
import WarehouseSelect from '@/components/WarehouseSelect.vue'
export default {
  name: 'goodsmanage',
  components: {
    pageTable,
    WarehouseSelect
  },
  data () {
    return {
      size: 10,
      page: 1,
      warehouseCode: ''
    }
  },
  computed: {
    // 列表数据
    notVerifyListd () {
      return goodsManage.state.notVerifyListd
    },
    fieldList () {
      return [
        { label: '商品名称', prop: 'name', width: 150, align: 'center' },
        { label: '商品属性', prop: 'typeName', width: 90, align: 'center' },
        { label: '规格', prop: 'standard', width: 150, align: 'center' },
        { label: '箱规（件/箱）', prop: 'box', width: 120, align: 'center' },
        { label: '商品类型', prop: 'weightTypeName', width: 100, align: 'center' },
        { label: '供应商', prop: 'supplier', width: 150, align: 'center' },
        { label: '分类', prop: 'ygcName', width: 150, align: 'center' },
        { label: '销售价', prop: 'salePrice', type: 'slot', align: 'center' },
        { label: '生产日期管理', prop: 'openStatus', width: 120, align: 'center', type: 'slot' },
        { label: '保质期(天)', prop: 'ygExpDays', width: 100, align: 'center', type: 'slot' },
        { label: '外箱长(cm)', prop: 'boxLong', width: 150, type: 'slot', align: 'center' },
        { label: '外箱宽(cm)', prop: 'boxWide', width: 150, type: 'slot', align: 'center' },
        { label: '外箱高(cm)', prop: 'boxHigh', width: 150, type: 'slot', align: 'center' },
        { label: '外箱体积(cm³)', prop: 'volume', width: 150, type: 'slot', align: 'center' },
        { label: '外箱毛重(kg)', prop: 'weight', width: 150, type: 'slot', align: 'center' },
        { label: '标准码放数', prop: 'standardCode', width: 150, align: 'center' },
        { label: '商品编码', prop: 'goodsCode', width: 170, align: 'center' },
        { label: '商品条码', prop: 'barCode', width: 150, align: 'center' },
        { label: '来源', prop: 'createFlag', width: 120, type: 'slot', align: 'center' },
        { label: '创建人', prop: 'creatName', width: 150, align: 'center' },
        { label: '创建时间', prop: 'createTime', width: 160, align: 'center' }
      ]
    },
    notVerifyMark () {
      return goodsManage.state.notVerifyMark
    }
  },
  watch: {
    notVerifyMark: {
      deep: true,
      handler (val) {
        if (val === 1) {
          goodsManage.state.notVerifyMark = 0
          this.getList()
        }
      }
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    // 分页刷新
    refresh (page, size) {
      this.page = page
      this.size = size
      this.getList()
    },
    search () {
      this.getList()
    },
    reset () {
      this.$refs.warehouseSelect.setValue()
      this.getList()
    },
    // 请求数据列表
    getList () {
      let params = {
        page: this.page,
        rows: this.size,
        type: true,
        warehouseCode: this.$refs.warehouseSelect.value
      }
      this.$store.dispatch(GETNOTPASSGOODD, params)
    },
    // 编辑
    edit (item) {
      this.$router.push({ path: `/goodsmanage/goodsedit/verify/${item.goodsCode}/${this.$refs.warehouseSelect.value}` })
    },
    // 已审
    examine (item) {
      let goodCodes = this.$refs.pageTable.multipleSelection.join(',')
      let message = '您确定将选中商品批量改为“已审”状态？'
      if (item) {
        goodCodes = item.goodsCode
        message = '您确定将该商品改为“已审”状态？'
      }
      if (!goodCodes) {
        return this.$alert('请至少选择一条信息。', '提示', {
          confirmButtonText: '知道了'
        })
      }
      this.$confirm(message, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          goodCodes
        }
        this.$store.dispatch(GOODSPASSGOOD, params)
      })
    },
    // 删除
    deletes (item) {
      this.$confirm('您确定要删除该商品？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          type: true,
          goodsCode: item.goodsCode
        }
        this.$store.dispatch(GOODSDELETE, params)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/goodsManage/NotVerify.vue